import { RcoCheckoutPackageStep } from "@redotech/redo-flows-common/advanced-flow-db-parser";
import { useTranslation } from "@redotech/redo-i18n";
import PackageIcon from "@redotech/redo-icons/package.svg";
import { RedoFeaturedIcon } from "@redotech/redo-web/arbiter-components/featured-icon/redo-featured-icon";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { Flex } from "@redotech/redo-web/flex";
import { Handle, Position } from "@xyflow/react";
import { memo } from "react";
import { PartialWithRequiredType } from "../steps";
import { BaseNode } from "./base-node";
import * as css from "./node.module.css";

export interface RcoCheckoutPackageNodeData {
  step: PartialWithRequiredType<RcoCheckoutPackageStep>;
  deleteElements: (id: string) => void;
}

export const RcoCheckoutPackageNode = memo(
  function RcoCheckoutPackageNode(data: {
    id: string;
    data: RcoCheckoutPackageNodeData;
    selected?: boolean | undefined;
  }) {
    const { t } = useTranslation();

    return (
      <BaseNode
        icon={<RedoFeaturedIcon color="gray" Icon={PackageIcon} size="xs" />}
        onDelete={() => data.data.deleteElements(data.id)}
        selected={data.selected}
        step={data.data.step as any}
        title={t("Package")}
      >
        <Handle id="top" position={Position.Top} type="target" />
        <Flex gap="md">
          <Flex className={css.halfInput}>
            <RedoTextInput
              label={t("Name")}
              setValue={() => {}}
              state="disabled"
              value={data.data.step.name ?? ""}
            />
          </Flex>
          <Flex className={css.halfInput}>
            <RedoTextInput
              label={t("Dimensions")}
              setValue={() => {}}
              state="disabled"
              value={data.data.step.dimensions ?? ""}
            />
          </Flex>
        </Flex>
      </BaseNode>
    );
  },
);
